import React, { useState, useEffect, useContext } from "react";
import DeploymentResourceMap from "./DeploymentResourceMap";
import DeploymentResourceForm from "./DeploymentResourceForm";
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { ThemeContext } from "../../../..";
import { getData } from "../../../../Services/Services";
import { getThemeURL } from "../../../../Services/EndPoints";


const DeploymentResourceAllocation = () => {
   const [selectedRegions, setSelectedRegions] = useState([]);
   const [selectedDistrictIds, setSelectedDistrictIds] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const [resourceDetails, setResourceDetails] = useState([]); // Add this state
   const [shouldHighlightOnMap, setShouldHighlightOnMap] = useState(false);
   const [incidentRegions, setIncidentRegions] = useState([]);
     const [stateId, setStateId] = useState(null);
   

const { theme } = useContext(ThemeContext);
   const location = useLocation();
   const { state } = useLocation();
   let id = state?.id;
   let resouceData = state?.fullResourcesData;
   console.log(" dropdown data resouceData", resouceData)
   // Initialize with Bihar state data
   useEffect(() => {
      setSelectedRegions([{
         name: "LADAKH",
         gis_id: null,
         id: stateId,
         region_type_id: null,
         level: 0
      }]);
   }, []);

console.log("resource detailse23",resourceDetails)
useEffect(()=>{
   getUserProfile();
})
const getUserProfile = async () => {
  try {
    const profile = await getData(getThemeURL);
    if (profile && profile.length > 0) {
      setStateId(profile[0].state_id);
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
  }
};
   // Function to update resource details
   const updateResourceDetails = (details, regions) => {
      setResourceDetails([details]); // Wrap in array to match DataTable expectations
      setIncidentRegions(regions || []); // Update incident regions
   };


   // Function to trigger map highlighting
   const handleLocateOnMap = () => {
      if (resourceDetails.length > 0) {
         setShouldHighlightOnMap(true);
      } else {
         toast.warning("Please select a resource first", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
         });
      }
   };


   return (
      <>
         <div className="mt-2 deployment-container">
            <div className="resource-form" style={{
               backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44", // white for light, dark for dark
               padding: "1rem",
               borderRadius: "8px",
            }}>
               <DeploymentResourceForm
                  resouceData={resouceData}
                  onResourceDetailsUpdate={(details, regions) => updateResourceDetails(details, regions)}
                  onLocateOnMap={handleLocateOnMap}
               />
            </div>
            <div className="rd_image_div map-sticky dr-map" style={{
               backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44", // white for light, dark for dark
               borderRadius: "8px",
            }}>
               <DeploymentResourceMap
                  resouceData={resourceDetails}
                  shouldHighlight={shouldHighlightOnMap}
                  incidentRegions={incidentRegions}
                 
               /> {/* Pass the details */}
            </div>
         </div>
      </>
   );
};


export default DeploymentResourceAllocation;